import { rangeByID, rangeCreate, rangeDestroy, rangeList, rangeUpdate } from '@/services/agency/ranges.service'

export default {
	namespaced: true,
	state: {
		// SERVICE RANGE
		rangeList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		range: {},

		// STATUS SERVICE RANGE
		rangeStatus: 'pending',
		rangeSaveStatus: 'init',
		rangeDeleteStatus: 'init',
	},
	getters: {
		// SERVICE RANGE
		getRangeList(state) {
			return state.rangeList
		},
		getRange(state) {
			return state.range
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE RANGE
		getRangeDeleteStatus(state) {
			return state.rangeDeleteStatus
		},
		getRangeSaveStatus(state) {
			return state.rangeSaveStatus
		},
		getRangeStatus(state) {
			return state.rangeStatus
		},
	},
	mutations: {
		// SERVICE RANGE
		RANGE_LIST(state, value) {
			state.rangeList = value
		},
		SET_RANGE(state, value) {
			state.range = value
		},

		// STATUS SERVICE RANGE
		RANGE_STATUS(state, value) {
			state.rangeStatus = value
		},
		RANGE_SAVE_STATUS(state, value) {
			state.rangeSaveStatus = value
		},
		RANGE_DELETE_STATUS(state, value) {
			state.rangeDeleteStatus = value
		},
	},
	actions: {
		// Service Range
		async fetchRangeList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('RANGE_STATUS', 'pending')
			commit('RANGE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await rangeList(params)
				commit('RANGE_STATUS', 'init')
				commit('RANGE_LIST', data)
				return data
			} catch (error) {
				commit('RANGE_STATUS', 'init')
				throw error
			}
		},
		async fetchRangeByID({ commit }, params) {
			commit('RANGE_STATUS', 'pending')
			try {
				const { data } = await rangeByID(params)
				commit('RANGE_STATUS', 'init')
				commit('SET_RANGE', data.data)
				return data
			} catch (error) {
				commit('RANGE_STATUS', 'init')

				return error
			}
		},
		async saveNewRange({ commit }, params) {
			commit('RANGE_SAVE_STATUS', 'pending')
			try {
				const { data } = await rangeCreate(params)
				commit('RANGE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('RANGE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateRange({ commit }, params) {
			commit('RANGE_SAVE_STATUS', 'pending')
			try {
				const { data } = await rangeUpdate(params)
				commit('RANGE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('RANGE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteRangeByID({ commit }, params) {
			commit('RANGE_DELETE_STATUS', 'pending')
			try {
				const { data } = await rangeDestroy(params)
				commit('RANGE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('RANGE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
